import type { Cohort } from '@efdigital/ll-addon-data';
import { selectValue } from '@efdigital/ll-addon-ui';
import SidebarContainer from '@efdigital/ll-xceed-v2/components/application/sidebar-container.gts';
import type { CoachingCoacheeCohortModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort';
import type CoacheeService from '@efdigital/ll-xceed-v2/services/coachee';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';

interface CoacheeSignature {
  Args: {
    model: CoachingCoacheeCohortModel;
    controller: unknown;
  };
}

function moreThanOne(array: unknown[]) {
  return array.length > 1;
}

export default class CoacheeCohortTemplate extends Component<CoacheeSignature> {
  @service declare coachee: CoacheeService;
  @service declare router: RouterService;

  get nav() {
    return [
      {
        link: {
          route: 'coaching.coachee.cohort.index',
          models: [this.args.model.program_id, this.args.model.cohort_id],
        },
        icon: 'ph:squares-four',
        label: 'Dashboard',
      },
      {
        link: {
          route: 'coaching.coachee.cohort.quiz',
          models: [this.args.model.program_id, this.args.model.cohort_id],
        },
        label: 'Onboarding Questionnaire',

        icon: 'ph:flask-fill',
      },
      {
        link: {
          route: 'coaching.coachee.cohort.coaches',
          models: [this.args.model.program_id, this.args.model.cohort_id],
        },
        label: 'Coaches',
        icon: 'ph:users',
      },
      {
        link: {
          route: 'coaching.coachee.cohort.sessions',
          models: [this.args.model.program_id, this.args.model.cohort_id],
        },
        label: 'Sessions',
        icon: 'ph:calendar',
      },
    ];
  }

  selectCohort = (cohortsWithCoaching: Cohort[], event: Event) => {
    const target = event.target as HTMLSelectElement;
    const cohortId = target.value;
    const cohort = cohortsWithCoaching.find(
      (cohort) => cohort.id === cohortId
    )!;
    this.router.transitionTo(
      'coaching.coachee.cohort.index',
      cohort.program.id,
      cohort.id
    );
  };

  <template>
    {{pageTitle "Coachee"}}
    {{#if @model.isCoachee}}
      <SidebarContainer @nav={{this.nav}}>
        <:sidebar as |className|>
          {{#if (moreThanOne @model.cohortsWithCoaching)}}
            <div class={{className}}>
              <select
                class="form-select"
                {{selectValue @model.cohort_id}}
                {{on
                  "change"
                  (fn this.selectCohort @model.cohortsWithCoaching)
                }}
                aria-label="Select a cohort"
              >
                {{#each @model.cohortsWithCoaching as |cohort|}}
                  <option value={{cohort.id}}>{{cohort.title}}</option>
                {{/each}}
              </select>
            </div>
          {{/if}}
        </:sidebar>
        <:content>
          {{outlet}}
        </:content>
      </SidebarContainer>
    {{else}}
      <div class="container py-5">
        <div class="alert alert-danger">
          You are not registered as a coachee. If you believe this is an error,
          please email
          <a
            href="mailto:v-support@hultashridge.com"
          >v-support@hultashridge.com</a>
        </div>
      </div>
    {{/if}}
  </template>
}
